import { notifyBugsnagHandledError } from './bugsnagClient';

const HISTORY_ERROR_NOTIFY_WINDOW_MS = 10000;

let isInstalled = false;
let lastNotifiedAt = 0;

const isErrorLike = (error: unknown): error is { name: string; message: string } => {
  return typeof error === 'object' && error !== null && 'name' in error && 'message' in error;
};

const shouldHandleHistoryRateLimitError = (error: unknown): boolean => {
  if (!isErrorLike(error)) {
    return false;
  }

  if (error.name !== 'SecurityError') {
    return false;
  }

  return error.message.includes('history.pushState()') && error.message.includes('more than 100 times');
};

const notifyOncePerWindow = (error: unknown) => {
  const now = Date.now();
  if (now - lastNotifiedAt < HISTORY_ERROR_NOTIFY_WINDOW_MS) {
    return;
  }

  lastNotifiedAt = now;
  notifyBugsnagHandledError(error as Error);
};

export const installHistorySafetyGuard = () => {
  if (isInstalled || typeof window === 'undefined') {
    return;
  }

  isInstalled = true;

  const wrapHistoryMethod = (method: 'pushState' | 'replaceState') => {
    const originalMethod = window.history[method].bind(window.history);

    window.history[method] = ((...args: Parameters<History['pushState']>) => {
      try {
        return originalMethod(...args);
      } catch (error) {
        if (shouldHandleHistoryRateLimitError(error)) {
          notifyOncePerWindow(error);
          return;
        }

        throw error;
      }
    }) as History['pushState'];
  };

  wrapHistoryMethod('pushState');
  wrapHistoryMethod('replaceState');
};

